export default __webpack_public_path__ + "static/media/grafica-democratica.4c176e03.png";